import { render } from "./Tips.vue?vue&type=template&id=cab82500&bindings={\"availableTips\":\"setup\",\"changeSlide\":\"setup\",\"task_id\":\"setup\"}"
import script from "./Tips.vue?vue&type=script&lang=js"
export * from "./Tips.vue?vue&type=script&lang=js"

import "./Tips.vue?vue&type=style&index=0&lang=css"
script.render = render

export default script